import classNames from 'classnames';

export const bemModifier = (baseClass, ...args) => [
  baseClass,
  ...args.map((value) => {
    if (typeof value === 'object') {
      return Object.keys(value).reduce((acc, key) => {
        acc[`${baseClass}--${key}`] = value[key];
        return acc;
      }, {});
    }

    return `${baseClass}--${value}`;
  }),
];

export const bemClassName = (baseClass, ...args) => classNames(...bemModifier(baseClass, ...args));
